import React from "react";
import styled from "styled-components";
import { Row, Col, Typography, Button, Tag, Space, Divider, Skeleton } from "antd";
import { MdBookmarkBorder, MdBookmark } from "react-icons/md";
import LatestTrade from "../../assets/images/Dashboard/LatestTrade.svg";
import TradingPartners from "../../assets/images/Dashboard/TradingPartners.svg";
import { capitalize } from "utils/randomString";
const { Title, Text } = Typography;
const RecommendationCard = styled.div`
  width: 100%;
  border: ${(props) => (props.bordered ? "1px solid #e8e8e8" : "none")};
  border-radius: 8px;
  background: #fff;
  padding: 20px;
`;

const TagComponent = styled(Tag)`
  border-radius: 2em;
  padding: 4px 9.5px;
  margin-right: 0.5em;
  background: #d5ed92;
  border: 0;
`;

export default function Card({
  title,
  country,
  str1,
  str2,
  tags,
  btnName,
  onClick,
  handleShortlist,
  id,
  isShortlisted,
  bordered,
  savingProspect,
  showShortlistButton
}) {
  return (
    <RecommendationCard bordered={bordered} className="recommendation-card">
      <Row justify="space-between">
        <Col>
          <Row>
            <Title className="recommendation-card-title">
              {capitalize(title)}
            </Title>
          </Row>
          <Row>
            <Text type="secondary"> {capitalize(country)}</Text>
          </Row>
        </Col>
        <Col>
        {
         showShortlistButton &&
          <Row
            align="top"
            className="recommendation-card-save"
            onClick={() =>
              handleShortlist(isShortlisted, { id, title, country })
            }
            style={{
              background: isShortlisted ? "#1D2624" : "rgba(4, 14, 12, 0.4)",
            }}
          >
            {isShortlisted ? (
              <MdBookmark size={"1.2em"} color={"#B6DA25"} />
            ) : (
              <MdBookmarkBorder size={"1.2em"} color={"white"} />
            )}

            <Text style={{ color: "white", fontSize: "0.875em" }}>
              {isShortlisted ? "Shortlisted" : "Shortlist"}
            </Text>
          </Row>
}
       </Col>
      </Row>
      <Divider style={{ margin: "0.5em 0px" }} />

      <Row
        style={{
          marginTop: "1em",
        }}
      >
        <Col span={24}>
          <Row align="middle">
            <Space>
              <img src={LatestTrade} alt="icon" width={40} />
              <Text ellipsis>
                {str1 ? `Last traded in ${capitalize(str1)}` : " - - - -"}
              </Text>
            </Space>
          </Row>

          <Row align="middle" style={{ marginTop: "1.5em" }}>
            <Space>
              <img src={TradingPartners} alt="icon" width={40} />
              <Text ellipsis>
                {str2
                  ? ` ${str2} ${
                      str2 === 1 ? "Trading partner" : "Trading partners"
                    } `
                  : " - - - -"}{" "}
              </Text>
            </Space>
          </Row>
        </Col>
      </Row>
      <Divider style={{ margin: "1em 0px" }} />

      <Row style={{ marginTop: "1em" }}>
        <Col span={24}>
          <Button style={{padding:0,width:'100%'}} type="link" size="large" onClick={onClick}>
            {btnName}
          </Button>
        </Col>
      </Row>
    </RecommendationCard>
  );
}
